import { useContext, useEffect, useState } from 'react';

import { Formik } from 'formik';
import { useLocation, useNavigate, useParams } from 'react-router';
import { Link } from 'react-router-dom';
import * as Yup from 'yup';

import { EventContext } from '../../Contexts/EventContext';
import Loading from '../../Shared/Components/Loading';
import ModalCustom from '../../Shared/Components/ModalCustom';
import Pagination from '../../Shared/Components/Pagination';
import { error, success } from '../../Shared/Components/Toast';
import useApi from '../../Shared/hooks/api/Index';
/** @format */
import Master from '../Layouts/Master';

const validationSchema = Yup.object().shape({});

const User = () => {
  const eventContext = useContext(EventContext);
  const navigate = useNavigate();
  const { id } = useParams();
  const { search } = useLocation();
  const [loading, setLoading] = useState(false);
  const [parseParams, setParseParams] = useState({});
  const [removeLoading, setRemoveLoading] = useState(false);
  const [userRemoveId, setUserRemoveId] = useState();
  const [modalIsOpen, setModalIsOpen] = useState(false);

  useEffect(() => {
    getUsers();
  }, [search, id]);

  const getUsers = async () => {
    setLoading(true);
    await useApi.get(
      `/user${search}`,
      {},
      (res) => {
        eventContext.users = res.data;
        setLoading(false);
      },
      (err) => {
        setLoading(false);
        error('هنگام دریافت اطلاعات خطایی رخ داده است');
      },
    );
  };
  // const searchUser = () => {
  //   if (natCode.length < 10 || natCode.length > 10) {
  //     error('کد ملی باید 10 رقم باشد');
  //     return;
  //   }

  //   return navigate(`/panel/user?nat_code=${natCode}`);
  // };

  const userFilter = (values, setSubmiting) => {
    let regexPaginate = new RegExp(/page=([0-9]+)/);
    let pageExists = regexPaginate.test(search);
    let paginate = parseParams?.page;

    let filter = pageExists ? `?page=${paginate}` : '';
    Object.entries(values).forEach((item) => {
      if (item[1] != 0 || item[1]?.length > 0) {
        filter +=
          filter.length > 0
            ? `&${item[0]}=${item[1]}`
            : `?${item[0]}=${item[1]}`;
      }
    });
    navigate(`/panel/user${filter}`);
  };

  const removeUser = async (userId) => {
    setRemoveLoading(true);

    await useApi.delete(
      `/user/${userId}`,
      {},
      (res) => {
        success('رویداد مورد نظر با موفقیت حذف شد');
        setRemoveLoading(false);
        setModalIsOpen(false);
        getUsers();
      },
      (err) => {
        setRemoveLoading(false);
        setLoading(false);
        error('حذف به علت خطا انجام نشد');
      },
    );
  };

  return loading ? (
    <Loading />
  ) : (
    <Master>
      <div className='d-flex flex-row justify-content-between border-bottom pb-2 my-3'>
        <div className='d-flex flex-row mt-2'>
          <i className='fad fa-list f-20 text-secondary mx-2'></i>
          <h1 className='text-secondary f-13 font-weight-bold mt-1 mb-0 p-0'>
            لیست کاربران
          </h1>
        </div>

        <Link
          to='/panel/user/create'
          className='d-flex flex-row btn btn-outline-info '
        >
          <i className='fad fa-plus f-16 mx-2'></i>
          <span className='f-13'>افزودن کاربر</span>
        </Link>
      </div>

      <Formik
        initialValues={{
          first_name: parseParams?.first_name ?? '',
          last_name: parseParams?.last_name ?? '',
          nat_code: parseParams?.nat_code ?? '',
          mobile: parseParams?.mobile ?? '',
        }}
        onSubmit={(values, { setSubmitting }) => {
          userFilter(values, setSubmitting);
        }}
        validationSchema={validationSchema}
      >
        {({
          values,
          errors,
          handleChange,
          handleSubmit,
          isSubmitting,
          setFieldValue,
        }) => (
          <form onSubmit={handleSubmit}>
            <div className='d-flex flex-row w-100 my-1'>
              <div className='form-group w-20'>
                <label className='f-14 text-right'>کد ملی</label>
                <input
                  type='text'
                  name='nat_code'
                  onChange={handleChange}
                  value={values?.nat_code}
                  className='form-control'
                />
              </div>
              <div className='form-group w-20 mx-2'>
                <label className='f-14 text-right'>موبایل</label>
                <input
                  type='text'
                  name='mobile'
                  onChange={handleChange}
                  value={values?.mobile}
                  className='form-control'
                />
              </div>
              <div className='form-group w-20 mx-2'>
                <label className='f-14 text-right'>نام</label>
                <input
                  type='text'
                  name='first_name'
                  onChange={handleChange}
                  value={values?.first_name}
                  className='form-control'
                />
              </div>
              <div className='form-group w-20 mx-2'>
                <label className='f-14 text-right'>نام خانوادگی</label>
                <input
                  type='text'
                  name='last_name'
                  onChange={handleChange}
                  value={values?.last_name}
                  className='form-control'
                />
              </div>
              <div className='form-group mt-2'>
                <button
                  type='submit'
                  className='btn bg-purple f-12 mt-4 mx-2 text-dark-mode'
                >
                  جستجو
                </button>
                <Link
                  to='/panel/user'
                  className='btn bg-secondary f-12 mt-4 mx-2 text-dark-mode'
                >
                  پاک کردن فیلتر ها
                </Link>
              </div>{' '}
            </div>
          </form>
        )}
      </Formik>

      <div className='w-100 overflow-auto'>
        {eventContext.users?.data?.length > 0 ? (
          <table className='table table-hover'>
            <thead>
              <tr>
                <th>#</th>
                <th>نام و نام خانوادگی</th>
                <th>کد ملی</th>
                <th>شماره همراه</th>
                <th>نقش ها</th>
                <th>تعیین نقش</th>
                <th>عملیات</th>
              </tr>
            </thead>
            <tbody>
              {eventContext.users?.data?.map((item, index) => (
                <tr key={item.id}>
                  <th>
                    {(eventContext.users.meta.pagination.current_page - 1) *
                      eventContext.users.meta.pagination.count +
                      (index + 1)}
                  </th>

                  <td>
                    {item?.first_name} {item?.last_name}
                  </td>

                  <td>{item?.nat_code ?? '-'}</td>
                  <td>{item?.mobile ?? '-'}</td>
                  <td>
                    {item.roles?.map((role) => (
                      <span className='text-secondary f-12'>
                        {role?.description}{' '}
                        {item?.roles[item?.roles.length - 1]?.id !== item.id
                          ? '-'
                          : ''}{' '}
                      </span>
                    ))}
                  </td>
                  <td>
                    <Link
                      to={`/panel/user/${item?.id}/role`}
                      className='btn btn-info f-13'
                    >
                      تعیین نقش
                    </Link>
                  </td>
                  <td>
                    <div className='d-flex flex-row'>
                      <Link
                        to={`/panel/user/edit/${item?.id}`}
                        className='mx-2'
                      >
                        ویرایش
                      </Link>
                      <Link
                        className='mx-2'
                        to='#'
                        onClick={(e) => {
                          e.preventDefault();
                          setUserRemoveId(item?.id);
                          setModalIsOpen(true);
                        }}
                      >
                        حذف
                      </Link>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        ) : (
          <div className='d-flex flex-row justify-content-center border p-3 my-3	'>
            <span className='f-13 font-weight-bold text-secondary'>
              کاربری ثبت نام نکرده است
            </span>
          </div>
        )}
      </div>
      <Pagination
        search={search}
        totalPage={eventContext.users?.meta?.pagination?.total_pages}
        basePath={`/panel/user`}
      />
      <ModalCustom modalIsOpen={modalIsOpen}>
        <div className='d-flex flex-row border-bottom pb-2'>
          <i className='fad fa-warning f-20 mx-2'></i>
          <span className=''>آیا از حذف فرم مطمئنید‌؟</span>
        </div>
        <div className='d-flex flex-row justify-content-around my-3'>
          <button
            onClick={() => setModalIsOpen(false)}
            className='btn btn-danger w-48 f-13'
          >
            لغو
          </button>
          <button
            onClick={() => removeUser(userRemoveId)}
            className='btn btn-success w-48 f-13'
          >
            {removeLoading ? (
              <div
                className='spinner-border spinner-border-sm text-white mb-1'
                role='status'
              ></div>
            ) : (
              'بله'
            )}
          </button>
        </div>
      </ModalCustom>
    </Master>
  );
};

export default User;
